import { Component, OnInit, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { CatalogsFacade, PrepareHtmlPipe } from '@boels/shared-state';
import { BaseSite, BoelsCategoryHierarchy } from '@boels/models';
import { map } from 'rxjs/operators';
import { CategoryItemComponent } from './category-item/category-item.component';
import { RoutingService, UrlSafePipe } from '@boels/helpers';
import { VerticalAlignerComponent } from '../vertical-aligner/vertical-aligner.component';
import { QaHooksDirective } from '@boels/helpers';

@Component({
  selector: 'boels-subcategories',
  templateUrl: './subcategories.component.html',
  styleUrls: ['./subcategories.component.scss'],
  imports: [
    AsyncPipe,
    PrepareHtmlPipe,
    QaHooksDirective,
    CategoryItemComponent,
    VerticalAlignerComponent,
  ],
})
export class SubcategoriesComponent implements OnInit {
  private readonly catalogsFacade = inject(CatalogsFacade);
  routingService = inject(RoutingService);
  private safeUrlPipe = inject(UrlSafePipe);

  categoryData$: Observable<BoelsCategoryHierarchy | undefined>;
  baseSite: BaseSite;

  ngOnInit(): void {
    this.categoryData$ = this.catalogsFacade.getCatalogs().pipe(
      map((catalog) => {
        const routeParams = this.routingService.getRouteProperty('params');
        let category: BoelsCategoryHierarchy | undefined =
          catalog?.categories[0]?.subcategories?.find(
            (subcategory) => subcategory.id === routeParams?.['categoryId'],
          );

        if (category && category.subcategories) {
          category = JSON.parse(JSON.stringify(category));
          if (category && category.subcategories) {
            category.subcategories = category.subcategories.map(
              (subcategory) => {
                if (subcategory) {
                  return {
                    ...subcategory,
                    url: this.addUrlsToSubcategories(category, subcategory),
                  };
                }
                return subcategory;
              },
            );
          }
        }
        return category;
      }),
    );
  }

  private addUrlsToSubcategories(
    category: BoelsCategoryHierarchy | undefined,
    subcategory: BoelsCategoryHierarchy,
  ): string {
    return `/${this.safeUrlPipe.transform(
      category?.boelsBreadcrumbs?.[0].categoryName,
    )}/${
      this.routingService.getRouteProperty('params')?.['name']
    }/${this.safeUrlPipe.transform(subcategory.name)}/c/${subcategory.id}`;
  }
}
